<template>
  <entry-point-page-template
    :key="productName"
    class="localized-text"
    :hashed-data-id="hashedDataId"
    :doctor-slug="doctorSlug"
  >
    <product-details-page-template
      :hashed-data-id="hashedDataId"
      :product-name="productName"
      :doctor-slug="doctorSlug"
    >
      <template v-slot:description>
        <component :is="customDescriptionComponent" :product-name="productName" />
      </template>

      <template v-slot:custom-sections>
        <serum-ingredients-details-section
          v-if="isSerum"
          :key="productName"
          :product-name="productName"
        />
        <making-serum-video-section v-if="isSerum" class="making-serum-section" />
        <constant-active-ingredient-details :product-name="productName" />
        <satisfaction-guaranteed-section v-if="isSerum" />
      </template>
    </product-details-page-template>
  </entry-point-page-template>
</template>

<script>
import ProductDetailsPageTemplate from '@/views/product-details/ProductDetailsPageTemplate.vue';
import ComplementaryProductDescription from '@/components/product-subpages/ComplementaryProductDescription.vue';
import SerumProductDescription from '@/components/product-subpages/SerumProductDescription.vue';
import EntryPointPageTemplate from '@/views/EntryPointPageTemplate.vue';
import ConstantActiveIngredientDetails from '@/components/product-subpages/ConstantActiveIngredientDetails.vue';
import SerumIngredientsDetailsSection from '@/components/product-subpages/SerumIngredientsDetailsSection.vue';
import SatisfactionGuaranteedSection from '@/components/product-subpages/SatisfactionGuaranteedSection.vue';
import MakingSerumVideoSection from '@/components/video-section/MakingSerumVideoSection.vue';

import { PRODUCT_NAMES } from '@/constants/treatment';

export default {
  name: 'ProductDetailsPage',
  components: {
    SerumProductDescription,
    ComplementaryProductDescription,
    ProductDetailsPageTemplate,
    EntryPointPageTemplate,
    ConstantActiveIngredientDetails,
    SerumIngredientsDetailsSection,
    SatisfactionGuaranteedSection,
    MakingSerumVideoSection
  },
  props: {
    productName: {
      type: String,
      required: true
    },
    doctorSlug: {
      type: String,
      required: true
    },
    hashedDataId: {
      type: String,
      required: true
    }
  },
  computed: {
    isSerum() {
      return [PRODUCT_NAMES.FACE_SERUM, PRODUCT_NAMES.EYE_CONTOUR_SERUM].includes(this.productName);
    },
    customDescriptionComponent() {
      if (this.isSerum) {
        return 'SerumProductDescription';
      }

      return 'ComplementaryProductDescription';
    }
  }
};
</script>

<style lang="scss" scoped>
@media (min-width: 600px) {
  .making-serum-section {
    margin-top: 72px;
  }
}

@media (min-width: 1200px) {
  .making-serum-section {
    margin-top: 8px;
  }
}

@media (min-width: 1440px) {
  .making-serum-section {
    margin-top: 24px;
  }
}
</style>
